// import React, { useState } from "react";
// import { auth, googleProvider } from "../../firebase/firebase";
// import { Link, useNavigate } from "react-router-dom";

// import {
//   OAuthProvider,
//   signInWithPopup,
//   // signInWithEmailAndPassword,
// } from "firebase/auth";
// import "./Login.css";

// export default function Login() {
//   const navigate = useNavigate();

//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [msg, setMsg] = useState("");
//   const [showPassword, setShowPassword] = useState(false); // <-- new state

//   // Email + password login
//   const handleEmailLogin = async (e) => {
//     e.preventDefault();

//     if (!email.trim() || !password.trim()) {
//       setMsg("Email and password are required.");
//       return;
//     }

//     try {
//       const resp = await fetch("https://agepcoatings.com/loginusercourse", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email, password }), // direct credentials
//       });

//       const data = await resp.json();
//       if (!resp.ok) throw new Error(data.error || "Login failed");

//       localStorage.setItem("user", JSON.stringify(data));
//       window.dispatchEvent(new Event("userChanged"));
//       setMsg("Login successful");
//       // navigate("/");

//       // Redirect based on usertype
//       if (data.userType === "admin") {
//         navigate("/adminpanel");
//       } else {
//         navigate("/");
//       }
//     } catch (err) {
//       console.error(err);
//       setMsg(err.message);
//     }
//   };

//   // Social login (Google & Apple)
//   const handleSocialLogin = async (providerName) => {
//     try {
//       let provider;
//       if (providerName === "google") {
//         provider = googleProvider;
//       } else if (providerName === "apple") {
//         provider = new OAuthProvider("apple.com");
//         provider.addScope("email");
//         provider.addScope("name");
//       }

//       const result = await signInWithPopup(auth, provider);
//       const idToken = await result.user.getIdToken();

//       // Send token in body (matches your backend registersocial route)
//       const resp = await fetch("https://agepcoatings.com/loginsocial", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ idToken }),
//       });

//       const data = await resp.json();
//       if (!resp.ok) throw new Error(data.error || "login failed");

//       localStorage.setItem("user", JSON.stringify(data));
//       window.dispatchEvent(new Event("userChanged")); // Notify Navbar of login
//       setMsg("login successful");
//       // navigate("/");
//       // Redirect based on usertype
//       if (data.userType === "admin") {
//         navigate("/adminpanel");
//       } else {
//         navigate("/");
//       }
//     } catch (err) {
//       console.error(err);
//       setMsg(err.message);
//     }
//   };
//   // Toggle show/hide password
//   const toggleShowPassword = () => {
//     setShowPassword((prev) => !prev);
//   };

//   return (
//     <div className="container login-container py-5">
//       <div className="row w-100 justify-content-end">
//         <div className="col-lg-5 col-md-8 col-sm-10">
//           <div className="login-right">
//             {msg && (
//               <div className="alert alert-info mt-3 w-100 text-center">
//                 {msg}
//               </div>
//             )}
//             <h3 className="fw-bold mb-4">Login</h3>

//             <form onSubmit={handleEmailLogin} className="w-100">
//               <div className="mb-3">
//                 <label>Email</label>
//                 <input
//                   type="email"
//                   className="form-control"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   required
//                 />
//               </div>

//               <div className="mb-3 position-relative">
//                 <label>Password</label>
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   className="form-control"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   required
//                 />
//                 <span
//                   onClick={toggleShowPassword}
//                   style={{
//                     position: "absolute",
//                     top: "29px",
//                     right: "12px",
//                     cursor: "pointer",
//                     color: "#666",
//                     userSelect: "none",
//                     fontSize: "1.2rem",
//                   }}
//                 >
//                   {showPassword ? (
//                     <i className="bi bi-eye-slash"></i>
//                   ) : (
//                     <i className="bi bi-eye"></i>
//                   )}
//                 </span>
//               </div>

//               <div className="text-end text-light mb-3">
//                 <Link to="/forgotpassword">Forgot?</Link>
//               </div>

//               <button
//                 type="submit"
//                 className="custom-login-btn border-0 w-100 mb-3"
//               >
//                 Login
//               </button>

//               <span className="d-flex flex-column justify-content-center align-items-center m-2">
//                 OR
//               </span>

//               <div className="d-flex gap-2 w-100">
//                 <button
//                   type="button"
//                   className="google-btn border-0 w-100"
//                   onClick={() => handleSocialLogin("google")}
//                 >
//                   <span className="google-icon">
//                     {/* Google SVG */}
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="18"
//                       height="18"
//                       viewBox="0 0 48 48"
//                     >
//                       <path
//                         fill="#4285F4"
//                         d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.84-6.84C35.4 2.92 29.97 0 24 0 14.6 0 6.44 5.45 2.56 13.36l7.91 6.14C12.44 13.13 17.73 9.5 24 9.5z"
//                       />
//                       <path
//                         fill="#34A853"
//                         d="M46.5 24.5c0-1.54-.14-3.02-.41-4.44H24v8.41h12.65c-.55 2.96-2.17 5.47-4.6 7.17l7.1 5.49C43.93 37.61 46.5 31.5 46.5 24.5z"
//                       />
//                       <path
//                         fill="#FBBC05"
//                         d="M10.47 28.05c-.48-1.39-.75-2.87-.75-4.55s.27-3.16.75-4.55l-7.91-6.14C1.06 15.45 0 19.57 0 24c0 4.43 1.06 8.55 2.56 12.14l7.91-6.14z"
//                       />
//                       <path
//                         fill="#EA4335"
//                         d="M24 48c6.48 0 11.9-2.13 15.87-5.81l-7.1-5.49c-2.02 1.35-4.63 2.14-8.77 2.14-6.27 0-11.56-3.63-13.53-8.86l-7.91 6.14C6.44 42.55 14.6 48 24 48z"
//                       />
//                       <path fill="none" d="M0 0h48v48H0z" />
//                     </svg>
//                   </span>
//                   Continue with Google
//                 </button>
//               </div>

//               <div className="col-12 mt-2">
//                 <p className="text-center text-secondary">
//                   Don’t have an account?{" "}
//                   <Link
//                     className="text-muted link-underline link-underline-opacity-0"
//                     to="/register"
//                   >
//                     Sign Up
//                   </Link>
//                 </p>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState } from "react";
import { auth, googleProvider } from "../../firebase/firebase";
import { Link, useNavigate } from "react-router-dom";

import {
  OAuthProvider,
  signInWithPopup,
  // signInWithEmailAndPassword,
} from "firebase/auth";
import "./Login.css";

export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [showPassword, setShowPassword] = useState(false); // <-- new state

  // Email + password login
  const handleEmailLogin = async (e) => {
    e.preventDefault();

    if (!email.trim() || !password.trim()) {
      setMsg("Email and password are required.");
      return;
    }

    try {
      const resp = await fetch("https://agepcoatings.com/loginusercourse", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }), // direct credentials
      });

      const data = await resp.json();
      if (!resp.ok) throw new Error(data.error || "Login failed");

      localStorage.setItem("user", JSON.stringify(data));
      window.dispatchEvent(new Event("userChanged"));
      setMsg("Login successful");
      // navigate("/");

      // Redirect based on usertype
      if (data.userType === "admin") {
        navigate("/adminpanel");
      } else {
        navigate("/");
      }
    } catch (err) {
      console.error(err);
      setMsg(err.message);
    }
  };

  // Social login (Google & Apple)
  const handleSocialLogin = async (providerName) => {
    try {
      let provider;
      if (providerName === "google") {
        provider = googleProvider;
      } else if (providerName === "apple") {
        provider = new OAuthProvider("apple.com");
        provider.addScope("email");
        provider.addScope("name");
      }

      const result = await signInWithPopup(auth, provider);
      const idToken = await result.user.getIdToken();

      // Send token in body (matches your backend registersocial route)
      const resp = await fetch("https://agepcoatings.com/loginsocial", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idToken }),
      });

      const data = await resp.json();
      if (!resp.ok) throw new Error(data.error || "login failed");

      localStorage.setItem("user", JSON.stringify(data));
      window.dispatchEvent(new Event("userChanged")); // Notify Navbar of login
      setMsg("login successful");
      // navigate("/");
      // Redirect based on usertype
      if (data.userType === "admin") {
        navigate("/adminpanel");
      } else {
        navigate("/");
      }
    } catch (err) {
      console.error(err);
      setMsg(err.message);
    }
  };
  // Toggle show/hide password
  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="container login-container py-5">
      <div className="row w-100 justify-content-end">
        <div className="col-lg-5 col-md-8 col-sm-10">
          <div className="login-right">
            {msg && (
              <div className="alert alert-info mt-3 w-100 text-center">
                {msg}
              </div>
            )}
            <h3 className="fw-bold mb-4">Login</h3>

            <form onSubmit={handleEmailLogin} className="w-100">
              <div className="mb-3">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3 position-relative">
                <label>Password</label>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span
                  onClick={toggleShowPassword}
                  style={{
                    position: "absolute",
                    top: "29px",
                    right: "12px",
                    cursor: "pointer",
                    color: "#666",
                    userSelect: "none",
                    fontSize: "1.2rem",
                  }}
                >
                  {showPassword ? (
                    <i className="bi bi-eye-slash"></i>
                  ) : (
                    <i className="bi bi-eye"></i>
                  )}
                </span>
              </div>

              <div className="text-end text-light mb-3">
                <Link to="/forgotpassword">Forgot?</Link>
              </div>

              <button
                type="submit"
                className="custom-login-btn border-0 w-100 mb-3"
              >
                Login
              </button>

              <span className="d-flex flex-column justify-content-center align-items-center m-2">
                OR
              </span>

              <div className="d-flex gap-2 w-100">
                <button
                  type="button"
                  className="google-btn border-0 w-100"
                  onClick={() => handleSocialLogin("google")}
                >
                  <span className="google-icon">
                    {/* Google SVG */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 48 48"
                    >
                      <path
                        fill="#4285F4"
                        d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.84-6.84C35.4 2.92 29.97 0 24 0 14.6 0 6.44 5.45 2.56 13.36l7.91 6.14C12.44 13.13 17.73 9.5 24 9.5z"
                      />
                      <path
                        fill="#34A853"
                        d="M46.5 24.5c0-1.54-.14-3.02-.41-4.44H24v8.41h12.65c-.55 2.96-2.17 5.47-4.6 7.17l7.1 5.49C43.93 37.61 46.5 31.5 46.5 24.5z"
                      />
                      <path
                        fill="#FBBC05"
                        d="M10.47 28.05c-.48-1.39-.75-2.87-.75-4.55s.27-3.16.75-4.55l-7.91-6.14C1.06 15.45 0 19.57 0 24c0 4.43 1.06 8.55 2.56 12.14l7.91-6.14z"
                      />
                      <path
                        fill="#EA4335"
                        d="M24 48c6.48 0 11.9-2.13 15.87-5.81l-7.1-5.49c-2.02 1.35-4.63 2.14-8.77 2.14-6.27 0-11.56-3.63-13.53-8.86l-7.91 6.14C6.44 42.55 14.6 48 24 48z"
                      />
                      <path fill="none" d="M0 0h48v48H0z" />
                    </svg>
                  </span>
                  Continue with Google
                </button>
              </div>

              <div className="col-12 mt-2">
                <p className="text-center text-secondary">
                  Don’t have an account?{" "}
                  <Link
                    className="text-muted link-underline link-underline-opacity-0"
                    to="/register"
                  >
                    Sign Up
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
